<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { isPaginatedCalls, type CallSummary } from '@calloneer/contracts';
import { apiRequest } from '../api.js';
const calls = ref<readonly CallSummary[]>([]);
const loading = ref(true);
onMounted(async () => {
  calls.value = (await apiRequest({ path: '/v1/me/calls', guard: isPaginatedCalls })).items;
  loading.value = false;
});
const duration = (seconds: number): string => `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
</script>

<template>
  <section class="panel">
    <div class="section-head">
      <div>
        <p class="eyebrow">PRIVATE TO YOU</p>
        <h1>Call history</h1>
      </div>
    </div>
    <p v-if="loading" class="muted">Loading calls…</p>
    <div v-else-if="calls.length === 0" class="empty">No calls yet.</div>
    <div v-else class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Destination</th>
            <th>Status</th>
            <th>Started</th>
            <th>Connected</th>
            <th>Cost</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in calls" :key="item.id">
            <td>{{ item.destination }}</td>
            <td>
              <span class="badge">{{ item.status }}</span>
            </td>
            <td>{{ new Date(item.startedAt).toLocaleString() }}</td>
            <td>{{ duration(item.connectedSeconds) }}</td>
            <td>{{ item.cost }} {{ item.currency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
